import type { OpportunitySelectOption } from "../types";

/** 客户来源：对齐老系统 TeamSelfDoDetail.aspx（value 入库，label 展示）。 */
export const CRM_OPPORTUNITY_SIGN_BUSI_SOURCE_OPTIONS: OpportunitySelectOption[] = [
  { value: "电销", label: "电话" },
  { value: "老客户介绍", label: "转介绍" },
  { value: "上门拜访", label: "陌生拜访" },
  { value: "市场活动（会议、行业活动等）", label: "会议等活动" },
  { value: "未知", label: "未知" },
  {
    value: "客户主动联系（400电话、联系花儿工作人员、官网留言）",
    label: "学生主动联系",
  },
  { value: "老客户有需求", label: "次变主" },
  { value: "资源合作", label: "资源合作" },
  { value: "搜索竞标", label: "搜索竞标" },
];

/** 赢单类型：对齐老系统 TeamSelfDoDetail.aspx。 */
export const CRM_OPPORTUNITY_SIGN_WIN_REASON_OPTIONS: OpportunitySelectOption[] = [
  { value: "关系网", label: "关系网" },
  { value: "学生中意", label: "学生中意" },
  { value: "价格优势", label: "价格优势" },
  { value: "线路专业", label: "线路专业" },
  { value: "品牌", label: "品牌" },
  { value: "HK", label: "HK" },
  { value: "市场活动", label: "市场活动" },
];

/** 输单类型：对齐老系统 TeamSelfDoDetail.aspx。 */
export const CRM_OPPORTUNITY_SIGN_LOSE_REASON_OPTIONS: OpportunitySelectOption[] = [
  { value: "价格高", label: "价格高" },
  { value: "关系不到位", label: "关系不到位" },
  { value: "学生做主", label: "学生做主" },
  { value: "对住宿方案等不满意", label: "对住宿方案等不满意" },
  { value: "取消", label: "取消" },
  { value: "负面影响", label: "负面影响" },
  { value: "走基地", label: "走基地" },
  { value: "未参与竞标", label: "未参与竞标" },
  { value: "竞标失败", label: "竞标失败" },
];

/** 列表输赢单筛选选项。 */
export const CRM_OPPORTUNITY_SIGN_INFO_STATUS_FILTER_OPTIONS: OpportunitySelectOption[] = [
  { value: "unfilled", label: "未填" },
  { value: "won", label: "赢单" },
  { value: "lost", label: "输单" },
];

/** 商机进度四选一：50%/80% 仅进度，赢单/输单展开签单表单。 */
export const CRM_OPPORTUNITY_PROGRESS_CHOICES = [
  { value: "50%", label: "50%" },
  { value: "80%", label: "80%" },
  { value: "won", label: "赢单" },
  { value: "lost", label: "输单" },
] as const;
